import React from 'react'
import AppPublishStatusView from '../AppPublishStatusView'
import { Button } from '@driftt/tide-core'
import statusSrc from './status.svg'
import './style.css'

const AppPendingPublish = ({ isPublishingApp, onPublishClick }) => (
  <div className="app-pending-publish">
    <AppPublishStatusView
      title="Success!"
      description="Your app is ready to be published to the Drift App Directory! Just press the green button and we’ll make your app public so that others can install your app."
      iconSrc={statusSrc}
    />
    <Button
      loading={isPublishingApp}
      className="app-pending-publish-button"
      onClick={onPublishClick}>
      Publish App to Drift Directory
    </Button>
  </div>
)

export default AppPendingPublish
